import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

import { Log } from "./utility";
import { AuthContext } from "../authContextProvider";
import { SignOutUser } from "../../firebase";

const Icons = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  errors: ErrorIcon,
  info: InfoIcon,
};

const SnackbarHooks = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("errors");
  const [logout, setLogout] = useState(false);
  const [push, setPush] = useState(false);
  const { setUser, setAppUser, logoutHandler } = useContext(AuthContext);

  const Close = () => {
    setOpen(false);
    if (logout) {
      setUser(null);
      setAppUser(null);
      SignOutUser().then(() => {
        logoutHandler();
        Log("Successfully logout from snackbar");
      });
    }
    if (push) navigate("/");
  };
  useImperativeHandle(ref, () => ({
    Open(text, types = "errors", action) {
      setOpen(true);
      setMessage(text);
      setType(types);
      if (action === "logout") {
        setLogout(true);
      }
      if (action === "push") {
        setPush(true);
      }
    },
  }));
  const Icon = Icons[type];
  return (
    <>
      {open && (
        <SnackbarStyled
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={open}
          onClose={Close}
          autoHideDuration={5000}
        >
          <SnackbarContent
            className={type}
            message={
              <>
                <Icon />
                <label>{message}</label>
                <IconButton
                  key="close"
                  aria-label="Close"
                  onClick={Close}
                  size="small"
                >
                  <CloseIcon fontSize="medium" size="small" />
                </IconButton>
              </>
            }
          />
        </SnackbarStyled>
      )}
    </>
  );
});
export default SnackbarHooks;
const SnackbarStyled = styled(Snackbar)`
  ${(props) => {
    let current = props.theme;
    return `
    >div{
      box-shadow: 0 3px 5px 2px rgba(${current.black}, 0.3)!important;
      border-radius: 4px!important;
      border: 0;
      min-width:unset!important;
      color: rgb(${current.white});
      ${
        props.anchorOrigin.horizontal === "right" &&
        `
      max-width:280px!important;
      `
      };
      
      >div{
        display:flex;
        align-items:center;
        padding:0!important;

        >label{
          margin-left: 10px;
          flex-grow:1;
          margin-bottom: 0;
        }
      }
    }
      .errors{
        background: rgb(${current.red});
      }
      .success{
        background: rgb(${current.green});
      }
      .warning{
        background: rgb(${current.orange});
      }
      .info{
        background: rgb(${current.blue});
      }
  `;
  }}
`;
